import api from 'api';

export const loadPages = api('GET /api/audit-logs/filters/pages');
export const loadTypes = api('GET /api/audit-logs/filters/types');
export const loadAllUsers = api('GET /api/audit-logs/filters/users');

export const loadManagers = api('GET /api/audit-logs/filters/managers');
